const baseurl = "https://api.lhrc.com.cn";
const baseimgurl = "https://www.lhrc.com.cn/"; 
// const baseurl = "https://localhost:44368";
// const baseimgurl = "http://localhost:8087/";
// const baseimgurl = "https://img.lhrc.com.cn/";以前用的，2026.9.23改了www.lhrc.com.cn/
const mapak = "Up7gmLUjWYQ2R4HQeOYmWQeaQlMOlzT5";
export default {
    baseurl,
    baseimgurl,
    mapak
}